// extracted by mini-css-extract-plugin
export default {"EscondeScrollBar":"estilo_EscondeScrollBar__cfmcK"};